import { cloudinaryImageUrl } from '@scentregroup/ui/tools/cloudinary/image'

const getStoreImageUrl = store => {
  const src = (store.image && store.image.src) || (store.logo && store.logo.src)
  return src ? cloudinaryImageUrl({ src, ratio: 'standard' }) : null
}

export default ({ url, store, title, description, country }) => {
  // TODO: In event a url is not available don't return incomplete structured data
  // - bit hackish, revist
  if (!url) {
    return null
  }

  return {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: title,
    url,
    description,
    mainEntity: {
      '@type': 'LocalBusiness',
      name: store.name || title,
      image: getStoreImageUrl(store),
      description: title,
      url,
    },
  }
}
